interface DTOBidStrengthProps {
  data: AdsResultFormatted
  costType: CostType
}

export const DTOBidStrength = ({
  data,
  costType
}: DTOBidStrengthProps): BidStrengthData | null => {
  if (!data) return null

  const settings = data.settings
  const campaignSettings = data.campaign_settings

  if (costType === 'cpc') {
    // 1 - Checa se deve usar ad settings
    if (settings?.cpc_cost_competitiveness) {
      return {
        status: settings.cpc_cost_competitiveness,
        suggestion: settings.cpc_suggested,
        costType
      }
    }

    // 2 - Checa se deve usar campaign settings
    if (campaignSettings?.cpc_cost_competitiveness) {
      return {
        status: campaignSettings.cpc_cost_competitiveness,
        suggestion: campaignSettings.cpc_suggested,
        costType
      }
    }
  }

  if (costType === 'cpm') {
    if (settings?.cpm_cost_competitiveness) {
      return {
        status: settings.cpm_cost_competitiveness,
        suggestion: settings.cpm_suggested,
        costType
      }
    }

    if (campaignSettings?.cpm_cost_competitiveness) {
      return {
        status: campaignSettings.cpm_cost_competitiveness,
        suggestion: campaignSettings.cpm_suggested,
        costType
      }
    }
  }

  return null
}
